import React from 'react'
import { Redirect } from 'react-router-dom'
import { publicRoute} from './util'
import App from './App'
import Login from './Login'
import Share from './Share'
import Signup from './Signup'
import Forgot from './Forgot'
import ResetPassword from './ResetPassword'
import VerifyEmail from './VerifyEmail'
import { getSession } from './auth'
import meta from './meta'

// Pages are only shown for the logged-in user; anyone else is sent to /login.
const requireAuth = ( Component ) => ( props ) => {
  return getSession() ? <Component {...props} /> : <Redirect to="/login" />
}
const RequireAuth = requireAuth( App )

// An album link opens inside the app for someone who is logged in (so they can listen, and save the
// album if they want it), and on the public page for everyone else.
const AppOrShare = ( props ) => {
  const path = props.location ? props.location.pathname : ''
  if (path.startsWith('/a/') && !getSession()) return <Share {...props} />
  return <RequireAuth {...props} />
}

export const routes = [
  {
    path: '/login',
    exact: true,
    component: publicRoute({
      meta: meta.home
    })( Login )
  },
  // One route for both so the app shell (and the player) stays mounted when moving between them.
  {
    path: ['/user', '/profile', '/u/:username', '/b/:bandId', '/a/:albumId'],
    exact: true,
    component: publicRoute({
      meta: meta.home
    })( AppOrShare )
  },
  {
    path: '/signup',
    exact: true,
    component: publicRoute({
      meta: meta.home
    })( Signup )
  },
  {
    path: '/forgot',
    exact: true,
    component: publicRoute({
      meta: meta.home
    })( Forgot )
  },
  {
    path: '/reset',
    exact: true,
    component: publicRoute({
      meta: meta.home
    })( ResetPassword )
  },
  {
    path: '/verify',
    exact: true,
    component: publicRoute({
      meta: meta.home
    })( VerifyEmail )
  },
  // Shareable song links; these don't require a login. (Album links, /a/..., are with the app above.)
  {
    path: '/s/:albumId/:songId',
    exact: true,
    component: publicRoute({
      meta: meta.home
    })( Share )
  }
]

export default routes
